import { render } from "./ConfigPreferGrupo.vue?vue&type=template&id=6be9a3d6&scoped=true&ts=true"
import script from "./ConfigPreferGrupo.vue?vue&type=script&lang=ts"
export * from "./ConfigPreferGrupo.vue?vue&type=script&lang=ts"

import "./ConfigPreferGrupo.vue?vue&type=style&index=0&id=6be9a3d6&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be9a3d6"]])

export default __exports__